// extracted by mini-css-extract-plugin
module.exports = {"Arrows":"Arrows_Arrows__31KNf"};